<div class="max-w-4xl mx-auto text-black">
  <h1 class="text-red-600 text-3xl font-bold mt-2">Impressum</h1>
  <hr class="my-4 border-slate-300"/>

  <h3 class="text-slate-900 text-xl font-semibold mt-2">
    Angaben zur allgemeinen Informationspflicht § 5 Telemediengesetz
  </h3>

  <p class="mt-6">Herausgeber:</p>

  <div class="mt-2">
    Württembergischer Schützenverband 1850 e.V. Fachverband für Schieß- und Bogensport<br>
    Präsident Reinhard Mangold<br>
    Fritz-Walter-Weg 19<br>
    70372 Stuttgart<br>
    Tel.: +49 (0) 7 11 / 2 80 77 - 300<br>
    E-Mail: <a href="mailto:info@wsv1850.de" class="text-slate-600 hover:text-slate-800">info&#64;wsv1850.de</a><br>
    Homepage: <a href="https://www.wsv1850.de" class="text-slate-600 hover:text-slate-800">www.wsv1850.de</a><br>
  </div>

  <p class="mt-6">eingetragen im Vereinsregister des Amtsgerichts Stuttgart: VR643</p>

  <p class="mt-6">Landesgeschäftsführer: Günter Schray</p>

  <p class="mb-3 mt-6">Vorstand:</p>

  <div>
    Präsident: Reinhard Mangold<br>
    1. Vizepräsident: Jens Eberius<br>
    2. Vizepräsident: Klaus Koch<br>
    3. Vizepräsident: Jürgen Richter<br>
    Landesschatzmeister: Klaus Müller<br>
    Landessportleiter: Rainer Hanisch<br>
    Landesjugendleiter: Katrin Rudau<br>
  </div>

  <p class="mt-6 mb-8">Umsatzsteueridentifikationsnummer: DE145792864</p>
</div>
